import * as React from 'react';

import { Text } from '@components/common';
import { ExclamationSVG } from '@components/svgs';

export const AllLogicEmptyState: React.FC = () => {
  return (
    <div className='flex flex-col items-center justify-center space-y-2 rounded-lg border border-gray-200 bg-white p-5 text-center'>
      <div className='mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 p-2'>
        <ExclamationSVG className='h-6 w-6' />
      </div>

      <Text className='text-md mb-2 font-semibold text-gray-700'>No logic set</Text>

      <Text className='text-xs text-gray-500'>
        Create rules at the question level to branch or mark answers as qualifying or disqualifying. Rules created will
        appear here for screener-level review.
      </Text>
    </div>
  );
};
